"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertToArray = convertToArray;
exports.getArray = getArray;
exports.getHashMap = getHashMap;
exports.insertInArray = insertInArray;
exports.removeFromArray = removeFromArray;
exports.replaceInArray = replaceInArray;
exports.uniq = uniq;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
/**
 * Recieves an array and returns a hash map using the key param as the hash key
 *
 * Example:
 *
 * ```
 * getHashMap([{ id: 'foo', name: 'Foo' }, { id: 'bar', name: 'Bar' }])
 * // {
 * //   foo: {
 * //     id: 'foo',
 * //     name: 'Foo'
 * //   },
 * //   bar: {
 * //     id: 'bar',
 * //     name: 'Bar'
 * //   }
 * // }
 * ```
 */
function getHashMap(array) {
  var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'id';
  return array.reduce(function (prev, current) {
    // eslint-disable-next-line no-param-reassign
    prev[current[key]] = current;
    return prev;
  }, {});
}

/**
 * Recieves a hash map and returns an array
 *
 * ```
 * getArray({ foo: 'bar', baz: 'quux' }) =>
 * ['bar', 'quux']
 * ```
 */
function getArray(hashMap) {
  return hashMap ? Object.keys(hashMap).map(function (key) {
    return hashMap[key];
  }) : undefined;
}

/**
 * Receives an object or an array and returns an array. Useful for query params
 */
function convertToArray(objectOrArray) {
  if (!objectOrArray) {
    return [];
  }
  if (Array.isArray(objectOrArray)) {
    return objectOrArray;
  }
  return [objectOrArray];
}

/**
 * Replaces an item in the array with a given new one
 */
function replaceInArray(array, item, params) {
  var index = 'findFn' in params ? array.findIndex(params.findFn) : params.index;
  return [].concat((0, _toConsumableArray2.default)(array.slice(0, index)), [item], (0, _toConsumableArray2.default)(array.slice(index + 1, array.length)));
}

/**
 * Inserts an item in an array in an specific index
 */
function insertInArray(array, item, params) {
  var index = 'findFn' in params ? array.findIndex(params.findFn) : params.index;
  var indexToInsert = index === -1 ? array.length : index;
  var newArray = (0, _toConsumableArray2.default)(array);
  newArray.splice(indexToInsert, 0, item);
  return newArray;
}

/**
 * Removes an item from an array
 */
function removeFromArray(array, params) {
  var index = 'findFn' in params ? array.findIndex(params.findFn) : params.index;
  return [].concat((0, _toConsumableArray2.default)(array.slice(0, index)), (0, _toConsumableArray2.default)(array.slice(index + 1, array.length)));
}
function uniq(array) {
  return Array.from(new Set((0, _toConsumableArray2.default)(array)));
}
//# sourceMappingURL=arrays.js.map